import React, { Component } from "react";
import { connect } from "react-redux";
import { Row, Col, message, Upload, Switch, InputNumber, Select } from "antd";
import { PictureOutlined, PrinterOutlined } from "@ant-design/icons";
import { FormItem, DynamicCardForm } from "../../../../Components/Items";
import SelectClientesItem from "../../../../Components/SelectClientesItem";
import ModalFormCMMS from "../componentes/ModalFormCMMS";
import { cmmsPost, normFile, fileListAPayload } from "../cmmsComun";

const { Option } = Select;

const soloImagen = (limiteMb) => (file) => {
    if (!/^image\/(png|jpe?g)$/.test(file.type)) {
        message.error("Use una imagen PNG o JPG");
        return Upload.LIST_IGNORE;
    }
    if (file.size / 1024 / 1024 >= limiteMb) {
        message.error(`La imagen debe pesar menos de ${limiteMb}MB`);
        return Upload.LIST_IGNORE;
    }
    return false;
};

// Margenes del contenido sobre la hoja membretada (puntos; carta = 612 x 792).
export const CamposMargenes = ({ prefijo = "margenes" }) => (
    <Row gutter={8}>
        {[
            ["arriba", "Arriba", 110],
            ["abajo", "Abajo", 90],
            ["izquierda", "Izquierda", 40],
            ["derecha", "Derecha", 40],
        ].map(([clave, etiqueta, def]) => (
            <Col xs={12} md={6} key={clave}>
                <FormItem label={etiqueta} name={[prefijo, clave]} initialValue={def}>
                    <InputNumber min={0} max={400} style={{ width: "100%" }} />
                </FormItem>
            </Col>
        ))}
    </Row>
);

// Hoja membretada / logo / datos que se imprimen para UN cliente.
class ModalClienteConfigCMMS extends Component {
    formRef = React.createRef();
    state = { loading: false };

    componentDidUpdate(prevProps) {
        if (this.props.visible && !prevProps.visible) {
            this.formRef.current?.resetFields();
            if (this.props.clienteId) this.consultar(this.props.clienteId);
        }
    }

    consultar = async (clienteId) => {
        this.setState({ loading: true });
        try {
            const res = await cmmsPost(this.props, "datosClienteConfigCMMS", { clienteId });
            if (res.data.success === 2) {
                const c = res.data.config;
                this.formRef.current?.setFieldsValue({ ...c, clienteId, margenes: c.margenesMembrete || {} });
            }
        } finally {
            this.setState({ loading: false });
        }
    };

    onFinish = async (values) => {
        this.setState({ loading: true });
        try {
            const [membrete] = await fileListAPayload(values.membrete);
            const [logoEtiqueta] = await fileListAPayload(values.logoEtiqueta);
            const [marcaAgua] = await fileListAPayload(values.marcaAgua);
            const res = await cmmsPost(this.props, "editarClienteConfigCMMS", {
                clienteId: values.clienteId,
                membrete: membrete || null,
                logoEtiqueta: logoEtiqueta || null,
                marcaAgua: marcaAgua || null,
                margenesMembrete: values.margenes,
                mostrarRfc: values.mostrarRfc,
                mostrarTelefono: values.mostrarTelefono,
                mostrarCorreo: values.mostrarCorreo,
                lineasFirma: values.lineasFirma,
            });
            if (res.data.success === 2) {
                message.success("Configuración del cliente guardada");
                this.props.onClose(true);
            } else message.error(res.data.message || "No se pudo guardar");
        } catch (error) {
            console.log(error);
            message.error("No se pudo guardar");
        } finally {
            this.setState({ loading: false });
        }
    };

    render() {
        return (
            <ModalFormCMMS
                titulo="Impresión para un cliente"
                subtitulo="Hoja membretada, marca de agua, logo de etiqueta y datos de este cliente. Lo que no suba se toma de la empresa."
                icono={<PrinterOutlined style={{ fontSize: 20, color: "#2fb8d6" }} />}
                visible={this.props.visible}
                loading={this.state.loading}
                onCancel={() => this.props.onClose(false)}
                formRef={this.formRef}
                name="clienteConfigCMMS"
                onFinish={this.onFinish}
                width={820}
            >
                <DynamicCardForm title="Cliente" xs={24}>
                    <FormItem label="Cliente" name="clienteId" required>
                        <SelectClientesItem
                            empresaId={this.props.empresaId}
                            headersToken={this.props.headersToken}
                            width="100%"
                            disabled={!!this.props.clienteId}
                            onChange={(clienteId) => clienteId && this.consultar(clienteId)}
                        />
                    </FormItem>
                </DynamicCardForm>
                <DynamicCardForm title="Hoja membretada" xs={24} md={14}>
                    <div className="cmms-ayuda">Imagen de la hoja completa tamaño carta (ej. el membrete de MEDIZIN XXI). Va de fondo en la Orden de Servicio.</div>
                    <FormItem name="membrete" valuePropName="fileList" getValueFromEvent={normFile} noStyle>
                        <Upload listType="picture-card" maxCount={1} accept="image/png,image/jpeg" beforeUpload={soloImagen(8)}>
                            <div>
                                <PictureOutlined />
                                <div style={{ marginTop: 6, fontSize: 12 }}>Membrete</div>
                            </div>
                        </Upload>
                    </FormItem>
                    <div style={{ fontSize: 12, fontWeight: 500, margin: "10px 0 2px" }}>Márgenes del contenido (puntos)</div>
                    <CamposMargenes />
                    <div style={{ fontSize: 12, fontWeight: 500, margin: "10px 0 2px" }}>Marca de agua</div>
                    <div className="cmms-ayuda">Logo que sale muy tenue al centro de cada hoja de la Orden de Servicio, los certificados y el reporte de visita de este cliente.</div>
                    <FormItem name="marcaAgua" valuePropName="fileList" getValueFromEvent={normFile} noStyle>
                        <Upload listType="picture-card" maxCount={1} accept="image/png,image/jpeg" beforeUpload={soloImagen(3)}>
                            <div>
                                <PictureOutlined />
                                <div style={{ marginTop: 6, fontSize: 12 }}>Marca de agua</div>
                            </div>
                        </Upload>
                    </FormItem>
                </DynamicCardForm>
                <DynamicCardForm title="Etiqueta y datos" xs={24} md={10}>
                    <div className="cmms-ayuda">Logo que sale en la etiqueta QR de los equipos de este cliente.</div>
                    <FormItem name="logoEtiqueta" valuePropName="fileList" getValueFromEvent={normFile} noStyle>
                        <Upload listType="picture-card" maxCount={1} accept="image/png,image/jpeg" beforeUpload={soloImagen(3)}>
                            <div>
                                <PictureOutlined />
                                <div style={{ marginTop: 6, fontSize: 12 }}>Logo</div>
                            </div>
                        </Upload>
                    </FormItem>
                    {[
                        ["mostrarRfc", "Mostrar RFC"],
                        ["mostrarTelefono", "Mostrar teléfono"],
                        ["mostrarCorreo", "Mostrar correo"],
                    ].map(([n, l]) => (
                        <FormItem key={n} name={n} valuePropName="checked" initialValue={true} style={{ marginBottom: 4 }}>
                            <Switch size="small" checkedChildren={l} unCheckedChildren={l} />
                        </FormItem>
                    ))}
                    <FormItem label="Líneas de firma" name="lineasFirma" initialValue={2}>
                        <Select>
                            <Option value={2}>2 · Ingeniero y área usuaria</Option>
                            <Option value={3}>3 · + Responsable de Biomédica</Option>
                        </Select>
                    </FormItem>
                </DynamicCardForm>
            </ModalFormCMMS>
        );
    }
}

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalClienteConfigCMMS);
